import { ValueInput } from '@utils/formattersV2';
import { chartColors } from '@utils/unifiedPlatformColorPalette';

export type RslColumnChartProps = {
  valueFormatter: (value: ValueInput) => string;
  yAxisValueFormatter: (value: ValueInput) => string;
  yAxisMinTickInterval?: number;
  data: {
    name: string;
    value: number;
  }[];
};

export const rslColumnChartOptions = (
  props: RslColumnChartProps
): Highcharts.Options => ({
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  title: {
    text: undefined,
  },
  tooltip: {
    enabled: false,
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    minTickInterval: props.yAxisMinTickInterval,
    title: {
      text: undefined,
    },
    labels: {
      formatter() {
        return props.yAxisValueFormatter(Number(this.value));
      },
    },
  },
  series: [
    {
      type: 'column',
      borderRadius: 5,
      colorByPoint: true,
      colors: chartColors,
      data: props.data.map(point => ({
        y: point.value,
        name: point.name,
      })),
      dataLabels: {
        enabled: true,
        style: {
          textOutline: 'none',
          fontWeight: 'bold',
        },
        formatter() {
          return props.valueFormatter(Number(this.y));
        },
      },
    },
  ],
});
